<template>
  <div>
    <b-card v-for="cgn in keys(values)" :key="cgn" class="vdist">
      <h5>{{ cgn }}</h5>

      <b-row v-for="cn in keys(values[cgn])" :key="cn">
        <b-col cols="12" md="3">
          {{ cn }}
        </b-col>
        <b-col cols="12" md="9">
          <b-progress :max="valueSum(values[cgn][cn])" show-value>
            <template v-for="(v,i) in keys(values[cgn][cn])">
              <b-progress-bar :key="'pb_'+v"
                              :id="cn+v"
                              :label="v"
                              :value="values[cgn][cn][v]"
                              :variant="i%2===0 ? 'primary' :'secondary'" />
<!--                              v-b-tooltip.hover :title="values[cgn][cn][v]"/>-->
              <b-tooltip :target="cn+v" :key="'tt_'+v">{{values[cgn][cn][v]}}</b-tooltip>
            </template>
          </b-progress>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>

export default {
  name: 'Distribution',
  props: ["values"],
  data: function () {
    return {}
  },

  methods: {
    valueSum(valueDict) {
      return this.keys(valueDict).map(x => valueDict[x]).reduce((acc, val) => acc + val, 0);
    },
    keys(x) {
      return Object.keys(x)
    }

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.on {
  color: red
}

.off {
  color: black
}
</style>
